import type { OnInit } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { IconName } from '@fortawesome/fontawesome-svg-core';
import { BehaviorSubject } from 'rxjs';

export interface SolarPanelsLoaderItem {
  icon: IconName;
  text: string;
}

@Component({
  selector: 'wl-solar-panels-loader',
  styleUrls: [
    './solar-panels-loader.component.essent.scss',
    './solar-panels-loader.component.ed.scss',
  ],
  templateUrl: './solar-panels-loader.component.html',
})
export class SolarPanelsLoaderComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subtitle = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() items: SolarPanelsLoaderItem[] = [];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() duration = 3000;

  @Output() finished: EventEmitter<undefined> = new EventEmitter();

  $step: BehaviorSubject<number> = new BehaviorSubject(0);
  maxSteps!: number;

  ngOnInit(): void {
    this.maxSteps = this.items.length;
    this.nextStep();
  }

  /**
   * makes progress and needed calculations to next step
   * adds step
   * recalculates new loaderWidth
   * wait for every duration of one step and if there is a next step call nextStep, else call finish
   */
  nextStep() {
    this.$step.next(this.$step.value + 1);
    setTimeout(
      () => {
        if (this.$step.value < this.maxSteps) {
          this.nextStep();
        } else {
          this.finished.emit();
        }
      },
      this.calculateDurationPerStep(this.duration, this.items.length)
    );
  }

  /**
   * calculates duration per step, added check to prevent divisions to 0
   */
  calculateDurationPerStep(totalDuration: number, steps: number): number {
    if (steps <= 0) {
      return totalDuration;
    }
    return totalDuration / steps;
  }
}
